AOS.init();

document.addEventListener("DOMContentLoaded", function () {
    function setExternalLinks() {
        const links = document.querySelectorAll(".mega-menu__link");
        const currentDomain = location.hostname.replace(/^www\./, "");

        links.forEach(link => {
            const href = link.getAttribute("href");
            if (!href || href.startsWith("#") || href.startsWith("javascript")) return;

            let url;
            try {
                url = new URL(href, location.origin);
            } catch {
                return;
            }

            const domain = url.hostname.replace(/^www\./, "");

            if (domain !== currentDomain) {
                link.target = "_blank";
                link.rel = "noopener noreferrer";
            }
        });
    }

    window.addEventListener("load", setExternalLinks);
    setTimeout(setExternalLinks, 800);
    setTimeout(setExternalLinks, 1500);
});

document.addEventListener("DOMContentLoaded", function () {
    const videoBoxes = document.querySelectorAll(".articleBoxMedia");

    videoBoxes.forEach((box) => {
        const video = box.querySelector("video");
        const playBtn = box.querySelector(".videoPlayBtn");

        if (!video || !playBtn) return;

        playBtn.addEventListener("click", function (e) {
            e.stopPropagation();

            document.querySelectorAll(".articleBoxMedia video").forEach((v) => {
                if (v !== video) {
                    v.pause();
                    v.controls = false;
                    v.closest(".articleBoxMedia").classList.remove("active");
                    const btn = v.closest(".articleBoxMedia").querySelector(".videoPlayBtn");
                    if (btn) btn.style.opacity = "1";
                }
            });

            if (video.paused) {
                video.play();
                video.controls = true;
                box.classList.add("active");
                playBtn.style.opacity = "0";
            } else {
                video.pause();
                video.controls = false;
                box.classList.remove("active");
                playBtn.style.opacity = "1";
            }
        });

        video.addEventListener("play", () => {
            playBtn.style.opacity = "0";
            video.controls = true;
        });

        video.addEventListener("pause", () => {
            playBtn.style.opacity = "1";
            video.controls = false;
        });

        video.addEventListener("ended", () => {
            playBtn.style.opacity = "1";
            video.controls = false;
        });
    });
});




